import { useQuery } from '@tanstack/react-query';
import { TimelineEntry } from '@blisspointmedia/bpm-types/dist/OfflineInputs';
import { fetchPromoTimeline } from '../api/data-qa-api';

export const promoTimelineQueryKey = (cid: string) => ['offlineInputsPromoTimeline', cid];

// The company's promo periods from Offline Inputs, for the Promo Flag's calendar view --
// fetched once the calendar first mounts.
export const usePromoTimeline = (cid: string) =>
  useQuery<TimelineEntry[]>({
    meta: { suppressGlobalError: true },
    queryKey: promoTimelineQueryKey(cid),
    queryFn: () => fetchPromoTimeline(cid),
    staleTime: Infinity,
    enabled: Boolean(cid)
  });
